import React, { useEffect, useState } from "react";
import ChkBox from "../../Custom/ChkBox";
import { Button, Popover, Autocomplete, TextField } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Btn from "components/Custom/Btn";

const PopOver = (props: any) => {
  const { childRef, data, name, onChange } = props;

  const [popstatus, setPopstatus] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const [filteredData, setFilteredData] = useState<any>(data);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // var dataLabel = data.map((item) => {
  //   return item.id;
  // });
  // console.log("dataLabel", dataLabel);

  const handlePopStatus = (event) => {
    setAnchorEl(event.currentTarget);
    setPopstatus(true);
  };

  const handlePopoverClose = () => {
    setPopstatus(false);
    setAnchorEl(null);
  };

  const onFilter = (check, id) => {
    setFilteredData((filteredData) => {
      let tmpList = [...filteredData];
      if (id === "All") {
        if (!tmpList.includes(id)) {
          tmpList = data.map((d) => d.id);
        } else {
          tmpList = [];
        }
      } else {
        if (!tmpList.includes(id)) {
          tmpList.push(id);
          if (tmpList.length === data.length - 1) {
            tmpList.push("All");
          }
        } else {
          tmpList = tmpList.filter((item) => item !== id && item !== "All");
        }
      }
      if (onChange) {
        onChange(tmpList);
      }
      return tmpList;
    });
    console.log("datas", data, id);
  };

  console.log("filteredData:", filteredData);
  console.log("data", data);

  return (
    <>
      <Btn
        variant="outlined"
        onClick={handlePopStatus}
        size="large"
        text={name}
        paddingTop={"1rem"}
        endIcon={<KeyboardArrowDownIcon />}
      />
      <Popover
        id={id}
        open={popstatus}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div style={{ marginLeft: "20px" }}>
          {data.map((item, index) => {
            return (
              <tr key={"data" + index}>
                <td>
                  <ChkBox
                    id={item.id}
                    text={item.label}
                    controlled={true}
                    checked={filteredData.indexOf(item.id) > -1}
                    onChange={onFilter}
                  />
                </td>
              </tr>
            );
          })}
        </div>
      </Popover>
    </>
  );
};

export default PopOver;
